export const PrivacyPolicy: React.FC = () => {
  return (
    <main className="bg-white-privacy py-20-privacy">
      <div className="container-privacy">
        <div className="content-wrapper-privacy">
          <h1 className="title-main-privacy">Privacy Policy</h1>

          {/* Intro paragraph */}
          <div className="section-privacy">
            Gallus Insights ("we," "our," or "us") is committed to protecting
            your privacy. This Privacy Policy explains how your personal
            information is collected, used, and disclosed by Gallus Insights.
            This Privacy Policy applies to our website, gallusinsights.com , and
            its associated subdomains (collectively, our "Service"). By
            accessing or using our Service, you signify that you have read,
            understood, and agree to our collection, storage, use, and
            disclosure of your personal information as described in this Privacy
            Policy and our Terms of Service.
          </div>
          <div className="section-privacy mb-2-privacy">
            <div className="section-header-privacy">
              Definitions and key terms
            </div>
            <div>
              To help explain things as clearly as possible in this Privacy
              Policy, every time any of these terms are referenced, are strictly
              defined as:
              <ul className="list-privacy">
                <li>
                  Cookie: small amount of data generated by a website and saved
                  by your web browser. It is used to identify your browser,
                  provide analytics, remember information about you such as your
                  language preference or login information.
                </li>
                <li>
                  Company: when this policy mentions “Company,” “we,” “us,” or
                  “our,” it refers to Gallus Insights Ltd., Gallus Insights Ltd.
                  that is responsible for your information under this Privacy
                  Policy.
                </li>
                <li>
                  Country: where Gallus Insights or the owners/founders of
                  Gallus Insights are based, in this case is United States.
                </li>
                <li>
                  Customer: refers to the company, organization or person that
                  signs up to use the Gallus Insights Service to manage the
                  relationships with your consumers or service users.
                </li>
                <li>
                  Device: any internet connected device such as a phone, tablet,
                  computer or any other device that can be used to visit Gallus
                  Insights and use the services.
                </li>
                <li>
                  IP address: Every device connected to the Internet is assigned
                  a number known as an Internet protocol (IP) address. These
                  numbers are usually assigned in geographic blocks. An IP
                  address can often be used to identify the location from which
                  a device is connecting to the Internet.
                </li>
                <li>
                  Personnel: refers to those individuals who are employed by
                  Gallus Insights or are under contract to perform a service on
                  behalf of one of the parties.
                </li>
                <li>
                  Personal Data: any information that directly, indirectly, or
                  in connection with other information — including a personal
                  identification number — allows for the identification or
                  identifiability of a natural person.
                </li>
                <li>
                  Service: refers to the service provided by Gallus Insights as
                  described in the relative terms (if available) and on this
                  platform.
                </li>
                <li>
                  Third-party service: refers to advertisers, contest sponsors,
                  promotional and marketing partners, and others whose products
                  or services we think may interest you.
                </li>
                <li>
                  Website: Gallus Insights’s site, which can be accessed via
                  this URL: gallusinsights.com.
                </li>
                <li>
                  You: a person or entity that is registered with Gallus
                  Insights to use the Services.
                </li>
              </ul>
            </div>
          </div>
          <div className="section-privacy mb-2-privacy">
            <div className="section-header-privacy">
              What Information Do We Collect?
            </div>
            <div>
              We collect information from you when you visit our service,
              register, place an order, subscribe to our newsletter, respond to
              a survey or fill out a form.
              <ul className="list-privacy">
                <li>Name / Username </li>
                <li>Email Addresses </li>
                <li>Job Titles </li>
                <li>Billing Addresses </li>
              </ul>
            </div>
          </div>
          <div className="section-privacy mb-2-privacy">
            <div className="section-header-privacy">
              How Do We Use The Information We Collect?
            </div>
            <div>
              Any of the information we collect from you may be used in one of
              the following ways:
              <ul className="list-privacy">
                <li>
                  To personalize your experience (your information helps us to
                  better respond to your individual needs)
                </li>
                <li>
                  To improve our service (we continually strive to improve our
                  service offerings based on the information and feedback we
                  receive from you){" "}
                </li>
                <li>
                  To improve customer service (your information helps us to more
                  effectively respond to your customer service requests and
                  support needs){" "}
                </li>
                <li>To process transactions </li>
                <li>
                  To administer a contest, promotion, survey or other site
                  feature{" "}
                </li>
                <li>To send periodic emails </li>
                <li>
                  All information collected is deleted after completion of the
                  contract. We keep no information about our clients, either
                  databases, files, procedures, etc. We simply delete all data.{" "}
                </li>
              </ul>
            </div>
            <div className="section-privacy mb-2-privacy">
              <div className="section-header-privacy">
                When do we use customer information from third parties?
              </div>
              <div>
                We receive some information from the third parties when you
                contact us. For example, when you submit your email address to
                us to show interest in becoming our customer, we receive
                information from a third party that provides automated fraud
                detection services to us. We also occasionally collect
                information that is made publicly available on social media
                websites. You can control how much of your information social
                media websites make public by visiting these websites and
                changing your privacy settings.
              </div>
            </div>
            <div className="section-privacy mb-2-privacy">
              <div className="section-header-privacy">
                Do we share the information we collect with third parties?
              </div>
              <div>Never, under any circumstances.</div>
            </div>
            <div className="section-privacy mb-2-privacy">
              <div className="section-header-privacy">
                Could my information be transferred to other countries?
              </div>
              <div>
                Never, your information is always stored in the US, under the
                most strict privacy and security.
              </div>
            </div>
            <div className="section-privacy mb-2-privacy">
              <div className="section-header-privacy">
                Is the information collected through our service secure?
              </div>
              <div>
                We take precautions to protect the security of your information.
                We have physical, electronic, and managerial procedures to help
                safeguard, prevent unauthorized access, maintain data security,
                and correctly use your information. However, neither people nor
                security systems are foolproof, including encryption systems. In
                addition, people can commit intentional crimes, make mistakes or
                fail to follow policies. Therefore, while we use reasonable
                efforts to protect your personal information, we cannot
                guarantee its absolute security. If applicable law imposes any
                nondisclaimable duty to protect your personal information, you
                agree that intentional misconduct will be the standards used to
                measure our compliance with that duty.
              </div>
            </div>
            <div className="section-privacy mb-2-privacy">
              <div className="section-header-privacy">
                Can I update or correct my information?
              </div>
              <div>
                The rights you have to request updates or corrections to the
                information we collect depend on your relationship with us.
                Personnel may update or correct their information as detailed in
                our internal company employment policies. Customers have the
                right to request the restriction of certain uses and disclosures
                of personally identifiable information as follows. You can
                contact us in order to (1) update or correct your personally
                identifiable information, (2) change your preferences with
                respect to communications and other information you receive from
                us, or (3) delete the personally identifiable information
                maintained about you on our systems (subject to the following
                paragraph), by cancelling your account. Such updates,
                corrections, changes and deletions will have no effect on other
                information that we maintain, or information that we have
                provided to third parties in accordance with this Privacy Policy
                prior to such update, correction, change or deletion. To protect
                your privacy and security, we may take reasonable steps (such as
                requesting a unique password) to verify your identity before
                granting you profile access or making corrections. You are
                responsible for maintaining the secrecy of your unique password
                and account information at all times. You should be aware that
                it is not technologically possible to remove each and every
                record of the information you have provided to us from our
                system. The need to back up our systems to protect information
                from inadvertent loss means that a copy of your information may
                exist in a non-erasable form that will be difficult or
                impossible for us to locate. Promptly after receiving your
                request, all personal information stored in databases we
                actively use, and other readily searchable media will be
                updated, corrected, changed or deleted, as appropriate, as soon
                as and to the extent reasonably and technically practicable. If
                you are an end user and wish to update, delete, or receive any
                information we have about you, you may do so by contacting the
                organization of which you are a customer.
              </div>
            </div>
            <div className="section-privacy mb-2-privacy">
              <div className="section-header-privacy">Personnel</div>
              <div>
                If you are one of our workers or applicants, we collect
                information you voluntarily provide to us. We use the
                information collected for Human Resources purposes in order to
                administer benefits to workers and screen applicants. You may
                contact us in order to (1) update or correct your information,
                (2) change your preferences with respect to communications and
                other information you receive from us, or (3) receive a record
                of the information we have relating to you. Such updates,
                corrections, changes and deletions will have no effect on other
                information that we maintain, or information that we have
                provided to third parties in accordance with this Privacy Policy
                prior to such update, correction, change or deletion.
              </div>
            </div>
            <div className="section-privacy mb-2-privacy">
              <div className="section-header-privacy">Sale of Business</div>
              <div>
                We reserve the right to transfer information to a third party in
                the event of a sale, merger or other transfer of all or
                substantially all of the assets of us or any of its Corporate
                Affiliates (as defined herein), or that portion of us or any of
                its Corporate Affiliates to which the Service relates, or in the
                event that we discontinue our business or file a petition or
                have filed against us a petition in bankruptcy, reorganization
                or similar proceeding, provided that the third party agrees to
                adhere to the terms of this Privacy Policy.
              </div>
            </div>
            <div className="section-privacy mb-2-privacy">
              <div className="section-header-privacy">Affiliates</div>
              <div>
                We may disclose information (including personal information)
                about you to our Corporate Affiliates. For purposes of this
                Privacy Policy, "Corporate Affiliate" means any person or entity
                which directly or indirectly controls, is controlled by or is
                under common control with us, whether by ownership or otherwise.
                Any information relating to you that we provide to our Corporate
                Affiliates will be treated by those Corporate Affiliates in
                accordance with the terms of this Privacy Policy.
              </div>
            </div>
            <div className="section-privacy mb-2-privacy">
              <div className="section-header-privacy">
                How Long Do We Keep Your Information?
              </div>
              <div>
                We keep your information only so long as we need it to provide
                service to you and fulfill the purposes described in this
                policy. This is also the case for anyone that we share your
                information with and who carries out services on our behalf.
                When we no longer need to use your information and there is no
                need for us to keep it to comply with our legal or regulatory
                obligations, we'll either remove it from our systems or
                depersonalize it so that we can't identify you. We delete all of
                our client’s information after the contract is finished.
              </div>
            </div>
            <div className="section-privacy mb-2-privacy">
              <div className="section-header-privacy">
                How Do We Protect Your Information?
              </div>
              <div>
                We implement a variety of security measures to maintain the
                safety of your personal information when you place an order or
                enter, submit, or access your personal information. We offer the
                use of a secure server. All supplied sensitive/credit
                information is transmitted via Secure Socket Layer (SSL)
                technology and then encrypted into our Payment gateway providers
                database only to be accessible by those authorized with special
                access rights to such systems, and are required to keep the
                information confidential. After a transaction, your private
                information (credit cards, social security numbers, financials,
                etc.) is never kept on file. We cannot, however, ensure or
                warrant the absolute security of any information you transmit to
                us or guarantee that your information on the Service may not be
                accessed, disclosed, altered, or destroyed by a breach of any of
                our physical, technical, or managerial safeguards.
              </div>
            </div>
            <div className="section-privacy mb-2-privacy">
              <div className="section-header-privacy">Governing Law</div>
              <div>
                The laws of United States, excluding its conflicts of law rules,
                shall govern this Agreement and your use of our service. Your
                use of our service may also be subject to other local, state,
                national, or international laws.
              </div>
            </div>
            <div className="section-privacy mb-2-privacy">
              <div className="section-header-privacy">Cookies</div>
              <div>
                We use "Cookies" to identify the areas of our website that you
                have visited. A Cookie is a small piece of data stored on your
                computer or mobile device by your web browser. We use Cookies to
                personalize the Content that you see on our website. Most web
                browsers can be set to disable the use of Cookies. However, if
                you disable Cookies, you may not be able to access functionality
                on our website correctly or at all. We never place Personally
                Identifiable Information in Cookies.
              </div>
            </div>
            <div className="section-privacy mb-2-privacy">
              <div className="section-header-privacy">Payment Details</div>
              <div>
                In respect to any credit card or other payment processing
                details you have provided us, we commit that this confidential
                information will be stored in the most secure manner possible.
              </div>
            </div>
            <div className="section-privacy mb-2-privacy">
              <div className="section-header-privacy">
                Changes To Our Privacy Policy
              </div>
              <div>
                If we decide to change our privacy policy, we will post those
                changes on this page, and/or update the Privacy Policy
                modification date above.
              </div>
            </div>
            <div className="section-privacy mb-2-privacy">
              <div className="section-header-privacy">Third-Party Services</div>
              <div>
                We may display, include or make available third-party content
                (including data, information, applications and other products
                services) or provide links to third-party websites or services
                ("Third- Party Services"). You acknowledge and agree that we
                shall not be responsible for any ThirdParty Services, including
                their accuracy, completeness, timeliness, validity, copyright
                compliance, legality, decency, quality or any other aspect
                thereof. We do not assume and shall not have any liability or
                responsibility to you or any other person or entity for any
                Third-Party Services. Third-Party Services and links thereto are
                provided solely as a convenience to you and you access and use
                them entirely at your own risk and subject to such third
                parties' terms and conditions.
              </div>
            </div>
            <div className="mb-2 text-lg font-bold ">Tracking Technologies</div>
            <div className="section-privacy mb-2-privacy">
              <div className="section-header-privacy">Google Maps APIs</div>
              <div>
                Google Maps API is a robust tool that can be used to create a
                custom map, a searchable map, check-in functions, display live
                data synching with location, plan routes, or create a mashup
                just to name a few. Google Maps API may collect information from
                You and from Your Device for security purposes. Google Maps API
                collects information that is held in accordance with its Privacy
                Policy.
              </div>
            </div>
            <div className="section-privacy mb-2-privacy">
              <div className="section-header-privacy">Cookies</div>
              <div>
                We use Cookies to enhance the performance and functionality of
                our service but are nonessential to their use. However, without
                these cookies, certain functionality like videos may become
                unavailable or you would be required to enter your login details
                every time you visit our service as we would not be able to
                remember that you had logged in previously.
              </div>
            </div>
            <div className="section-privacy mb-2-privacy">
              <div className="section-header-privacy">Local Storage</div>
              <div>
                Local Storage, sometimes known as DOM storage, provides web apps
                with methods and protocols for storing client-side data. Web
                storage supports persistent data storage, similar to cookies but
                with a greatly enhanced capacity and no information stored in
                the HTTP request header.
              </div>
            </div>
            <div className="section-privacy mb-2-privacy">
              <div className="section-header-privacy">Sessions</div>
              <div>
                We use "Sessions" to identify the areas of our website that you
                have visited. A Session is a small piece of data stored on your
                computer or mobile device by your web browser.
              </div>
            </div>
            <div className="section-privacy mb-2-privacy">
              <div className="text-lg font-bold">
                Information about General Data Protection Regulation (GDPR)
              </div>
              <div>
                We may be collecting and using information from you if you are
                from the European Economic Area (EEA), and in this section of
                our Privacy Policy we are going to explain exactly how and why
                is this data collected, and how we maintain this data under
                protection from being replicated or used in the wrong way.
              </div>
            </div>
            <div className="section-privacy mb-2-privacy">
              <div className="section-header-privacy">What is GDPR?</div>
              <div>
                GDPR is an EU-wide privacy and data protection law that
                regulates how EU residents' data is protected by companies and
                enhances the control the EU residents have, over their personal
                data.
              </div>
            </div>
            <div className="section-privacy mb-2-privacy">
              <div className="section-header-privacy">
                What is personal data?
              </div>
              <div>
                Any data that relates to an identifiable or identified
                individual. GDPR covers a broad spectrum of information that
                could be used on its own, or in combination with other pieces of
                information, to identify a person. Personal data extends beyond
                a person’s name or email address. Some examples include
                financial information, political opinions, genetic data,
                biometric data, IP addresses, physical address, sexual
                orientation, and ethnicity. The Data Protection Principles
                include requirements such as:
                <ul className="list-privacy">
                  <li>
                    Personal data collected must be processed in a fair, legal,
                    and transparent way and should only be used in a way that a
                    person would reasonably expect.{" "}
                  </li>
                  <li>
                    Personal data should only be collected to fulfil a specific
                    purpose and it should only be used for that purpose.
                    Organizations must specify why they need the personal data
                    when they collect it.{" "}
                  </li>
                  <li>
                    Personal data should be held no longer than necessary to
                    fulfil its purpose.{" "}
                  </li>
                  <li>
                    People covered by the GDPR have the right to access their
                    own personal data. They can also request a copy of their
                    data, and that their data be updated, deleted, restricted,
                    or moved to another organization.
                  </li>
                </ul>
              </div>
            </div>
            <div className="section-privacy mb-2-privacy">
              <div className="section-header-privacy">
                Why is GDPR important?
              </div>
              <div>
                GDPR adds some new requirements regarding how companies should
                protect individuals' personal data that they collect and
                process. It also raises the stakes for compliance by increasing
                enforcement and imposing greater fines for breach. Beyond these
                facts it's simply the right thing to do. At Help Scout we
                strongly believe that your data privacy is very important and we
                already have solid security and privacy practices in place that
                go beyond the requirements of this new regulation.
              </div>
            </div>
            <div className="section-privacy mb-2-privacy">
              <div className="section-header-privacy">
                Individual Data Subject's Rights - Data Access, Portability and
                Deletion
              </div>
              <div>
                We are committed to helping our customers meet the data subject
                rights requirements of GDPR. processes or stores all personal
                data in fully vetted, DPA compliant vendors. We do store all
                conversation and personal data for up to 6 years unless your
                account is deleted. In which case, we dispose of all data in
                accordance with our Terms of Service and Privacy Policy, but we
                will not hold it longer than 60 days. We are aware that if you
                are working with EU customers, you need to be able to provide
                them with the ability to access, update, retrieve and remove
                personal data. We got you! We've been set up as self service
                from the start and have always given you access to your data and
                your customers data. Our customer support team is here for you
                to answer any questions you might have about working with the
                API.
              </div>
            </div>
            <div className="section-privacy mb-2-privacy">
              <div className="section-header-privacy">California Residents</div>
              <div>
                The California Consumer Privacy Act (CCPA) requires us to
                disclose categories of Personal Information we collect and how
                we use it, the categories of sources from whom we collect
                Personal Information, and the third parties with whom we share
                it, which we have explained above. We are also required to
                communicate information about rights California residents have
                under California law. You may exercise the following rights:
                <ul className="list-privacy">
                  <li>
                    Right to Know and Access. You may submit a verifiable
                    request for information regarding the: (1) categories of
                    Personal Information we collect, use, or share; (2) purposes
                    for which categories of Personal Information are collected
                    or used by us; (3) categories of sources from which we
                    collect Personal Information; and (4) specific pieces of
                    Personal Information we have collected about you.{" "}
                  </li>
                  <li>
                    Right to Equal Service. We will not discriminate against you
                    if you exercise your privacy rights.{" "}
                  </li>
                  <li>
                    Right to Delete. You may submit a verifiable request to
                    close your account and we will delete Personal Information
                    about you that we have collected.
                  </li>
                  <li>
                    Request that a business that sells a consumer's personal
                    data, not sell the consumer's personal data. If you make a
                    request, we have one month to respond to you.{" "}
                  </li>
                </ul>
                If you would like to exercise any of these rights, please
                contact us. We do not sell the Personal Information of our
                users. For more information about these rights, please contact
                us.
              </div>
            </div>
            <div className="section-privacy mb-2-privacy">
              <div className="section-header-privacy">
                California Online Privacy Protection Act (CalOPPA)
              </div>
              <div>
                CalOPPA requires us to disclose categories of Personal
                Information we collect and how we use it, the categories of
                sources from whom we collect Personal Information, and the third
                parties with whom we share it, which we have explained above.
                CalOPPA users have the following rights:
                <ul className="list-privacy">
                  <li>
                    Right to Know and Access. You may submit a verifiable
                    request for information regarding the: (1) categories of
                    Personal Information we collect, use, or share; (2) purposes
                    for which categories of Personal Information are collected
                    or used by us; (3) categories of sources from which we
                    collect Personal Information; and (4) specific pieces of
                    Personal Information we have collected about you.{" "}
                  </li>
                  <li>
                    Right to Equal Service. We will not discriminate against you
                    if you exercise your privacy rights.{" "}
                  </li>
                  <li>
                    Right to Delete. You may submit a verifiable request to
                    close your account and we will delete Personal Information
                    about you that we have collected.
                  </li>
                  <li>
                    Request that a business that sells a consumer's personal
                    data, not sell the consumer's personal data.
                  </li>
                </ul>
                If you make a request, we have one month to respond to you. If
                you would like to exercise any of these rights, please contact
                us. We do not sell the Personal Information of our users. For
                more information about these rights, please contact us.
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};
